<template>
  <AppMain class="settings">
    <SettingsTopBar />
    <div class="settings-panel">
      <router-view
        v-slot="{ Component }"
        @track-page-load="$emit('track-page-load', $event)"
      >
        <component :is="Component" />
      </router-view>
    </div>
  </AppMain>
</template>

<script>
import { mapActions } from 'pinia';
import AppMain from '@/components/shared/AppMain.vue';
import SettingsTopBar from '@/components/settings/components/SettingsTopBar.vue';
import { useSettingsConfig } from '../stores/settings/config';

export default {
  name: 'SettingsView',
  components: {
    AppMain,
    SettingsTopBar,
  },
  emits: ['track-page-load'],
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Settings' });
  },
  async mounted() {
    await this.load();
  },
  methods: {
    ...mapActions(useSettingsConfig, ['load']),
  },
};
</script>
<style scoped>
.settings-panel {
  text-align: left;
}
</style>
